var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-ancestor is-parent" }, [
    _c("div", { staticClass: "tile is-parent" }, [
      _c(
        "article",
        { staticClass: "tile is-child" },
        [
          _vm.isLoadingDocuments
            ? _c("div", [
                _c("div", { staticClass: "is-size-5 mb-2 has-text-grey" }, [
                  _vm._v("Loading documents..."),
                ]),
                _c(
                  "div",
                  { staticClass: "columns is-multiline dragable-box" },
                  _vm._l(8, function (n) {
                    return _c(
                      "div",
                      {
                        key: `doc-skeleton-${n}`,
                        staticClass: "column is-narrow p-2",
                      },
                      [_vm._m(0, true)]
                    )
                  }),
                  0
                ),
              ])
            : _vm.documentsWithInfo.length === 0
            ? _c(
                "div",
                { staticClass: "content has-text-grey has-text-centered" },
                [_vm._m(1), _c("div", [_vm._v("No Documents")])]
              )
            : _vm._l(_vm.categoriesWithDocuments, function (category) {
                return [
                  _c("div", { key: category.categoryId, staticClass: "tile" }, [
                    _c("div", { staticClass: "tile is-parent" }, [
                      _c("article", { staticClass: "tile is-child" }, [
                        _c("div", { staticClass: "columns" }, [
                          _c("div", { staticClass: "column" }, [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "category-name is-size-4 has-text-weight-semibold",
                              },
                              [_vm._v(_vm._s(category.name))]
                            ),
                            _c("div", { staticClass: "is-size-5" }, [
                              _vm._v(" " + _vm._s(_vm.subtitle) + " "),
                              _c(
                                "span",
                                {
                                  class: {
                                    "has-text-danger":
                                      _vm.categorySelectedCount(category) >
                                      _vm.maxSelected,
                                  },
                                },
                                [
                                  _vm._v(
                                    " (" +
                                      _vm._s(
                                        _vm.categorySelectedCount(category)
                                      ) +
                                      "/" +
                                      _vm._s(category.documents.length) +
                                      ") "
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _c("div", { staticClass: "column is-narrow" }, [
                            _c("div", { staticClass: "buttons" }, [
                              category.documents.length > 0
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "button tooltip",
                                      attrs: { "data-tooltip": "Select all" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.setSelectedStatusAll(
                                            category,
                                            true
                                          )
                                        },
                                      },
                                    },
                                    [_vm._m(2, true)]
                                  )
                                : _vm._e(),
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.categoryHasSelected(category),
                                      expression:
                                        "categoryHasSelected(category)",
                                    },
                                  ],
                                  staticClass: "button tooltip",
                                  attrs: { "data-tooltip": "Deselect all" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.setSelectedStatusAll(
                                        category,
                                        false
                                      )
                                    },
                                  },
                                },
                                [_vm._m(3, true)]
                              ),
                            ]),
                          ]),
                        ]),
                        _c(
                          "div",
                          { staticClass: "columns is-multiline dragable-box" },
                          _vm._l(category.documents, function (doc, index) {
                            return _c(
                              "div",
                              {
                                key: doc.quoteAttachmentId || index,
                                staticClass: "column is-narrow p-2",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "card document-card",
                                    class: {
                                      "document-card--sent": doc.isSent,
                                    },
                                    staticStyle: {
                                      "box-shadow": "0 0 0 1px #d9d9d9",
                                    },
                                  },
                                  [
                                    _c(
                                      "header",
                                      { staticClass: "card-header" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "card-header-title p-2",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "control" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "pretty p-icon p-curve p-smooth",
                                                    staticStyle: {
                                                      "font-size": "0.875rem",
                                                    },
                                                  },
                                                  [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: doc.isSelected,
                                                          expression:
                                                            "doc.isSelected",
                                                        },
                                                      ],
                                                      attrs: {
                                                        id: `chk-pretty-document${category.categoryId}-${index}`,
                                                        name: `chk-pretty-select-document${category.categoryId}-${index}`,
                                                        type: "checkbox",
                                                      },
                                                      domProps: {
                                                        checked: Array.isArray(
                                                          doc.isSelected
                                                        )
                                                          ? _vm._i(
                                                              doc.isSelected,
                                                              null
                                                            ) > -1
                                                          : doc.isSelected,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$a =
                                                              doc.isSelected,
                                                            $$el =
                                                              $event.target,
                                                            $$c = $$el.checked
                                                              ? true
                                                              : false
                                                          if (
                                                            Array.isArray($$a)
                                                          ) {
                                                            var $$v = null,
                                                              $$i = _vm._i(
                                                                $$a,
                                                                $$v
                                                              )
                                                            if ($$el.checked) {
                                                              $$i < 0 &&
                                                                _vm.$set(
                                                                  doc,
                                                                  "isSelected",
                                                                  $$a.concat([
                                                                    $$v,
                                                                  ])
                                                                )
                                                            } else {
                                                              $$i > -1 &&
                                                                _vm.$set(
                                                                  doc,
                                                                  "isSelected",
                                                                  $$a
                                                                    .slice(
                                                                      0,
                                                                      $$i
                                                                    )
                                                                    .concat(
                                                                      $$a.slice(
                                                                        $$i + 1
                                                                      )
                                                                    )
                                                                )
                                                            }
                                                          } else {
                                                            _vm.$set(
                                                              doc,
                                                              "isSelected",
                                                              $$c
                                                            )
                                                          }
                                                        },
                                                      },
                                                    }),
                                                    _vm._m(4, true),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "card-content document-card-content has-text-centered p-2",
                                      },
                                      [
                                        _c(
                                          "figure",
                                          {
                                            staticClass:
                                              "image document-preview",
                                          },
                                          [
                                            _c("img", {
                                              staticClass: "document-thumb",
                                              attrs: {
                                                src: _vm.thumbnailUrl(doc),
                                                alt: "",
                                              },
                                              on: { error: _vm.onThumbError },
                                            }),
                                          ]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "document-filename is-size-7",
                                            attrs: { title: doc.filename },
                                          },
                                          [_vm._v(_vm._s(doc.filename))]
                                        ),
                                        _c(
                                          "div",
                                          { staticClass: "document-tags" },
                                          [
                                            doc.fileSize
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "tag is-small",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatFileSize(
                                                          doc.fileSize
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "tag document-status-tag",
                                                class: doc.isSent
                                                  ? "is-success"
                                                  : "is-warning",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "icon is-small",
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "mdi",
                                                      class: doc.isSent
                                                        ? "mdi-check-circle"
                                                        : "mdi-alert-circle-outline",
                                                    }),
                                                  ]
                                                ),
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      doc.isSent
                                                        ? "Sent"
                                                        : "Not sent"
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                      ]),
                    ]),
                  ]),
                ]
              }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card document-card skeleton-card" }, [
      _c("div", { staticClass: "skeleton-block skeleton-check" }),
      _c(
        "div",
        {
          staticClass:
            "card-content document-card-content has-text-centered p-3",
        },
        [
          _c("div", { staticClass: "skeleton-block skeleton-icon" }),
          _c("div", { staticClass: "skeleton-block skeleton-filename" }),
          _c("div", { staticClass: "skeleton-block skeleton-tag" }),
        ]
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { attrs: { icon: "icon is-large" } }, [
      _c("i", { staticClass: "mdi mdi-48px mdi-emoticon-sad" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-success" }, [
      _c("i", { staticClass: "mdi mdi-select-all mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-grey" }, [
      _c("i", { staticClass: "mdi mdi-select-off mdi-24px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "state p-success" }, [
      _c("i", { staticClass: "icon mdi mdi-check" }),
      _c("label"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }